import { stringify } from "query-string";

interface playerParams {
  playerId: number;
  circuitCode?: string;
}

interface playerWinLossParams {
  player1Id: number;
  player2Id: number;
  circuitCode: string;
}

interface playerActivityParams {
  player1Id: number;
  player2Id: number;
  circuitCode: string;
  year: number | string;
}

const playerDetailsEndPoint =
  "/tennis/api/PlayerApi/GetHeadToHeadPlayerDetails?";
const playerWinLoss = "/tennis/api/PlayerApi/GetPlayerWinLoss?";
const playerActivity = "/tennis/api/PlayerApi/GetPlayerActivity?";

export async function getPlayerDetails(playerId: number, circuitCode?: string) {
  let params: playerParams = {
    playerId
  };
  if (circuitCode) {
    params["circuitCode"] = circuitCode;
  }

  const response = await fetch(
    `${process.env.HOST}${playerDetailsEndPoint}${stringify(params)}`
  );
  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}

export async function getPlayerWinLoss(
  player1Id: number,
  player2Id: number,
  circuitCode: string
) {
  let params: playerWinLossParams = {
    player1Id,
    player2Id,
    circuitCode
  };
  const response = await fetch(
    `${process.env.HOST}${playerWinLoss}${stringify(params)}`
  );
  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}

export async function getPlayerActivity(
  player1Id: number,
  player2Id: number,
  circuitCode: string,
  year: number | string = ""
) {
  let params: playerActivityParams = {
    player1Id,
    player2Id,
    circuitCode,
    year
  };
  const response = await fetch(
    `${process.env.HOST}${playerActivity}${stringify(params)}`
  );
  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}
